import { KeyValue } from "@/main/models/common";
import { getTranslateByKey } from "@/main/services/utils";
import { z } from "zod";

const requiredMsg = (fieldKey: string) =>
	getTranslateByKey("information.isRequired", true).replace("{0}", getTranslateByKey(fieldKey));

const keyValueSchema = z.custom<KeyValue>();

const requiredKeyValue = (fieldKey: string) =>
	keyValueSchema.nullable().refine((v): v is KeyValue => v !== null, {
		error: () => requiredMsg(fieldKey),
	});

export const termsOfUseFilterSchema = z.object({
	country: requiredKeyValue("information.country"),
	companyType: requiredKeyValue("information.companyType"),
	culture: requiredKeyValue("information.userLanguage"),
	company: z.array(keyValueSchema),
	systemApplication: requiredKeyValue("information.systemApplication"),
	fileType: keyValueSchema.nullable(),
	statusRegister: requiredKeyValue("information.status"),
});

export type ITermsOfUseFilterForm = z.input<typeof termsOfUseFilterSchema>;
export type ITermsOfUseFilterFormOutput = z.output<typeof termsOfUseFilterSchema>;

export const INITIAL_TERMS_OF_USE_FORM: ITermsOfUseFilterForm = {
	country: null,
	companyType: null,
	company: [],
	systemApplication: null,
	fileType: null,
	statusRegister: null,
	culture: null,
};
